import { Breakpoints } from "../../../breakpoints";
import { slideDown, slideToggleDefaults, slideUp } from "../../modules/_SlideToggleHelpers";

export const ColorFlipCardList = () => ({
  "x-data"() {
    return {
      activeItem: null,
    };
  },
  "x-init"() {
    if (window.innerWidth <= Breakpoints.lg) {
      // setTimeout(() => {
      //   this.$data.activeItem = 0;
      // }, 100);
    }
  },
});

const getCurrentItemIndex = (item, allItems) => {
  return [...allItems].findIndex(x => x == item);
}

export const ColorFlipCard = () => ({
  "x-data"() {
    return {
      isActive: false,
      itemIndex: getCurrentItemIndex(this.$el, this.$el.parentNode.children),
    }
  },
  "x-init"() {
    this.$watch('activeItem', (activeItemValue) => {
      this.$data.isActive = activeItemValue == this.$data.itemIndex;
    });
  },
  "@mouseenter"() {
    if (window.innerWidth <= Breakpoints.lg) return;

    document.body.style.backgroundColor = this.$el.dataset.color;

    this.$data.activeItem = getCurrentItemIndex(this.$el, this.$el.parentNode.children);
  },
  "@mouseleave"() {
    if (window.innerWidth <= Breakpoints.lg) return;

    document.body.style.backgroundColor = null;

    this.$data.activeItem = null;
  },
  "@click"(e) {
    if (window.innerWidth > Breakpoints.lg) return;

    const currentItem = getCurrentItemIndex(this.$el, this.$el.parentNode.children);

    // Open container
    if (currentItem != this.$data.activeItem) {
      e.preventDefault();
      e.stopPropagation();

      this.$data.activeItem = currentItem;
    }
    else {
      // Double click allows link to open
    }
  }
  // "x-data"() {
  //   return {
  //     isHover: false,
  //     isActive: false,
  //     itemIndex: getCurrentItemIndex(this.$el, this.$el.parentNode.children),
  //     color: this.$el.dataset.color,
  //   }
  // },
  // "x-init"() {
  //   const el = 'color-flip-card';

  //   this.$watch('isActive', (isActiveValue) => {

  //     const inner = this.$el.querySelector(`.${el}__inner`);
  //     const mobileTeaser = this.$el.querySelector(`.${el}__mobile-teaser`);
  //     if (isActiveValue) {
  //       slideDown(inner, slideToggleDefaults);
  //       slideUp(mobileTeaser, slideToggleDefaults);
  //     }
  //     else {
  //       slideUp(inner, slideToggleDefaults);
  //       slideDown(mobileTeaser, slideToggleDefaults);
  //     }

  //     [...this.$el.parentNode.children].map((item,itemIndex) => {
  //       if (itemIndex == this.$data.itemIndex) {
  //         console.log(item, item.$el);
  //         item.$data.isActive = false;
  //       }
  //     });
  //   });
  // },
  // "@mouseenter"() {
  //   if (window.innerWidth >= Breakpoints.lg) {
  //     document.body.style.backgroundColor = this.$data.color;
  //     this.$data.isHover = true;
  //   }
  //   else {
  //     // this.$data.isActive = true;
  //   }
  // },
  // "@mouseleave"() {
  //   if (window.innerWidth >= Breakpoints.lg) {
  //     document.body.style.backgroundColor = null;
  //     this.$data.isHover = false;
  //   }
  //   else {
  //     // this.$data.isActive = false;
  //   }
  // },
  // "@click"(e) {
  //   if (window.innerWidth < Breakpoints.lg) {
  //     this.$data.isActive = true;
  //   }
  // }
});

export const ColorFlipCardInit = () => {
  Alpine.bind('ColorFlipCard', ColorFlipCard);
  Alpine.bind('ColorFlipCardList', ColorFlipCardList);
}

// document.addEventListener('alpine:init', () => {
//   window.Alpine.bind('ColorFlipCard', ColorFlipCard);
//   window.Alpine.bind('ColorFlipCardList', ColorFlipCardList);
// });
